import { createFileRoute } from "@tanstack/react-router";
import { SITE } from "@/lib/site";

export const Route = createFileRoute("/termos-de-uso")({
  head: () => ({
    meta: [
      { title: "Termos de Uso | SVG Multimídia" },
      {
        name: "description",
        content:
          "Termos de Uso da SVG Multimídia: regras de utilização do site, dos conteúdos e dos serviços de SEO, criação de sites e otimização de Ficha do Google.",
      },
      { name: "robots", content: "index,follow" },
    ],
  }),
  component: TermosPage,
});

function TermosPage() {
  const updated = "26 de junho de 2026";
  return (
    <article className="container-svg max-w-3xl py-16">
      <header className="mb-10">
        <p className="text-xs uppercase tracking-widest text-primary">Documento legal</p>
        <h1 className="mt-2 text-4xl font-semibold">Termos de Uso</h1>
        <p className="mt-3 text-sm text-muted-foreground">Última atualização: {updated}</p>
      </header>

      <div className="prose prose-invert max-w-none space-y-6 text-[15px] leading-relaxed text-muted-foreground">
        <section>
          <h2 className="text-foreground">1. Aceitação dos termos</h2>
          <p>
            Ao acessar e utilizar o site da {SITE.name} ("nós", "nosso", "empresa"), você declara
            ter lido, compreendido e concordado com estes Termos de Uso. Caso não concorde com
            qualquer cláusula, recomendamos que interrompa o uso do site.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">2. Sobre a empresa</h2>
          <p>
            A {SITE.name} (CNPJ 57.063.169/0001-08) é uma empresa especializada em SEO, criação de
            sites e otimização de Ficha do Google, com sede em Frederico Westphalen/RS.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">3. Uso do site</h2>
          <p>
            Você se compromete a utilizar este site apenas para finalidades lícitas, respeitando a
            legislação vigente, bons costumes e direitos de terceiros. É proibido:
          </p>
          <ul className="list-disc pl-6">
            <li>Reproduzir, copiar ou redistribuir conteúdos sem autorização expressa;</li>
            <li>Tentar acessar áreas restritas ou explorar vulnerabilidades;</li>
            <li>Utilizar bots, scrapers ou ferramentas automatizadas não autorizadas;</li>
            <li>Publicar conteúdo ofensivo, falso ou que viole direitos autorais.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-foreground">4. Propriedade intelectual</h2>
          <p>
            Todos os textos, imagens, logotipos, layouts, marcas, códigos e materiais publicados
            neste site são de propriedade da {SITE.name} ou utilizados sob licença, e são
            protegidos pelas leis de propriedade intelectual.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">5. Conteúdo informativo</h2>
          <p>
            Os conteúdos do blog e das páginas de serviço têm caráter informativo. A {SITE.name}
            não garante resultados específicos de posicionamento no Google, uma vez que os
            algoritmos de busca são dinâmicos e dependem de múltiplos fatores externos.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">6. Serviços contratados</h2>
          <p>
            A contratação de serviços é regida por contrato específico firmado entre as partes,
            que prevalece sobre qualquer informação contida neste site.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">7. Links de terceiros</h2>
          <p>
            Este site pode conter links para sites externos. A {SITE.name} não se responsabiliza
            por conteúdos, práticas ou políticas de privacidade de terceiros.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">8. Limitação de responsabilidade</h2>
          <p>
            A {SITE.name} não se responsabiliza por danos indiretos decorrentes do uso ou da
            indisponibilidade temporária do site, exceto nos casos previstos em lei.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">9. Alterações</h2>
          <p>
            Estes Termos podem ser atualizados a qualquer momento. A versão vigente estará sempre
            disponível nesta página, com a respectiva data de atualização.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">10. Foro</h2>
          <p>
            Fica eleito o foro da comarca de Frederico Westphalen/RS para dirimir quaisquer
            controvérsias decorrentes destes Termos, com renúncia a qualquer outro, por mais
            privilegiado que seja.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">11. Contato</h2>
          <p>
            Dúvidas sobre estes Termos podem ser enviadas para{" "}
            <a href={`mailto:${SITE.email}`} className="text-primary hover:underline">
              {SITE.email}
            </a>{" "}
            ou pelo WhatsApp {SITE.phoneDisplay}.
          </p>
        </section>
      </div>
    </article>
  );
}
